import utils from './utils/common'
import store from '../../store'
export default {
    install(Vue) {
        /**
         * @function
         * @description - 将省-市格式的字符串转成市
         * @param {String} city - 需转换的省-市字符串
         */
        Vue.prototype.$resetCity = function(city) {
            if(!city) return city
            let tempCity = city.split('-')

            if(tempCity.length == 2) {

                if(tempCity[0].match('特别行政')) {
                    return tempCity[0]
                } else {
                    return tempCity[1]
                }

            } else {
                return city
            }
        },
        /**
		 * @author：xf
		 * @function: Base64操作
		 * 
		 */
		Vue.prototype.$codeOper = function() {
			// 创建Base64对象
			var Base64 = {
			 _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
			 encode: function(e) {
                var t = "";
                var n, r, i, s, o, u, a;
                var f = 0;
                e = Base64._utf8_encode(e);
                while (f < e.length) {
                n = e.charCodeAt(f++);
                r = e.charCodeAt(f++);
                i = e.charCodeAt(f++);
                s = n >> 2;
                o = (n & 3) << 4 | r >> 4;
                u = (r & 15) << 2 | i >> 6;
                a = i & 63;
                if (isNaN(r)) {
                    u = a = 64
                } else if (isNaN(i)) {
                    a = 64
                }
                t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
                }
                return t
			 },
			 decode: function(e) {
                var t = "";
                var n, r, i;
                var s, o, u, a;
                var f = 0;
                e=e.replace(/[^A-Za-z0-9+/=]/g,"");
                while (f < e.length) {
                s = this._keyStr.indexOf(e.charAt(f++));
                o = this._keyStr.indexOf(e.charAt(f++));
                u = this._keyStr.indexOf(e.charAt(f++));
                a = this._keyStr.indexOf(e.charAt(f++));
                n = s << 2 | o >> 4;
                r = (o & 15) << 4 | u >> 2;
                i = (u & 3) << 6 | a;
                t = t + String.fromCharCode(n);
                if (u != 64) {
                    t = t + String.fromCharCode(r)
                }
                if (a != 64) {
                    t = t + String.fromCharCode(i)
                }
                }
                t = Base64._utf8_decode(t);
                return t
			 },
			 _utf8_encode: function(e) {
                e = e.replace(/rn/g, "n");
                var t = "";
                for (var n = 0; n < e.length; n++) {
                var r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r)
                } else if (r > 127 && r < 2048) {
                    t += String.fromCharCode(r >> 6 | 192);
                    t += String.fromCharCode(r & 63 | 128)
                } else {
                    t += String.fromCharCode(r >> 12 | 224);
                    t += String.fromCharCode(r >> 6 & 63 | 128);
                    t += String.fromCharCode(r & 63 | 128)
                }
                }
                return t
			 },
			 _utf8_decode: function(e) {
                var t = "";
                var n = 0;
                var r = 0;
                var c1 = r;
                var c2 = r;
                var c3;
                while (n < e.length) {
                r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r);
                    n++
                } else if (r > 191 && r < 224) {
                    c2 = e.charCodeAt(n + 1);
                    t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                    n += 2
                } else {
                    c2 = e.charCodeAt(n + 1);
                    c3 = e.charCodeAt(n + 2);
                    t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                    n += 3
                }
                }
                return t
                }
			}

			return Base64;
        }
        /**
         * @description - 拼接文件路径
         * @param {String} filePath - 文件相对路径
         * @returns - 文件路径
         */
        Vue.prototype.$fileUrl = function(filePath) {
            return `${store.state.global.baseUrl}bsd/attach/down?filePath=${filePath}`
        }
        /**
         * @description - 日期字符串重新格式化
         * @param {String} date - 日期字符串
         * @param {String} format - 格式化模板
         */
        Vue.prototype.$format = function(date, format) {
            if(!date) {
                return date
            }
            date = date.replace(/-/g, "/")
            return utils.dateFormat(new Date(date).getTime(), format || 'yyyy-MM-dd')
        }

        /**
         * 替换换行符
         * @param {string} text
         */
        Vue.prototype.$replaceBr = function(text) {
            if(!text) return text
			return text.replace(/\n/g, '<br/>')
		}
        Vue.prototype.$cutBytes = utils.cutBytes,
        Vue.prototype.$dateFormat = utils.dateFormat
        Vue.prototype.$deepCopy = utils.deepCopy
        Vue.prototype.$deepCopyExtend = utils.deepCopyExtend
    }
}


// WEBPACK FOOTER //
// ./src/comm/js/methods.vue.plugin.js